import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CardProdutividadeResumo from '../Components/Produtividade/CardProdutividadeResumo';
import CardProdutividadeFiltro from '../Components/Produtividade/CardProdutividadeFiltro';
import CardResumoImobiliaria from '../Components/Produtividade/CardResumoImobiliaria';
import Loading from '../Components/Loading';
import CardCorretoresEmpreendimentos from '../Components/Produtividade/CardCorretoresEmpreendimentos';
import CardDetalhesVenda from '~/Components/Produtividade/CardDetalhesVenda';
import {
  FaChevronRight,
  FaChartLine,
  FaChartBar,
  FaListAlt,
  FaFileContract,
} from 'react-icons/fa';
import RelatorioRescisoes from '~/Pages/RelatorioRescisoes';
import {
  selecionaCorretor,
  selecionaImobiliaria,
  selecionaEmpreendimento,
} from '~/Store/Produtividade/actions';
import CardComissaoFiltro from '~/Components/Comissao/CardComissaoFiltro';
import CardComissaoResumo from '~/Components/Comissao/CardComissaoResumo';
import CardComissoesMensais from '~/Components/Comissao/CardComissoesMensais';
import CardVendasDetalhadas from '~/Components/Produtividade/CardVendasDetalhadas';

const TABS = {
  PRODUTIVIDADE: 'produtividade',
  PROJECAO: 'projecao',
  VENDAS_DETALHADAS: 'vendas_detalhadas',
  RESCISOES: 'rescisoes',
};

class Produtividade extends Component {
  state = {
    isSearchActive: false,
    activeTab: TABS.PRODUTIVIDADE,
  };

  onClickTodos() {
    const {
      selecionaEmpreendimento,
      selecionaCorretor,
      selecionaImobiliaria,
    } = this.props;
    selecionaImobiliaria(null);
    selecionaCorretor(null);
    selecionaEmpreendimento(null);
  }

  onClickImobiliaria() {
    const {
      corretorSelecionado,
      empreendimentoSelecionado,
      selecionaEmpreendimento,
      selecionaCorretor,
    } = this.props;
    if (corretorSelecionado) selecionaCorretor(null);
    else if (empreendimentoSelecionado) selecionaEmpreendimento(null);
  }

  handleTabChange = tab => {
    this.setState({ activeTab: tab });
  };

  renderTabContent() {
    const { activeTab } = this.state;
    const {
      carregandoProdutividade,
      carregandoComissoes,
      imobiliariaSelecionada,
      corretorSelecionado,
      empreendimentoSelecionado,
    } = this.props;

    const detalhesSelecionado =
      corretorSelecionado || empreendimentoSelecionado;

    switch (activeTab) {
      case TABS.PRODUTIVIDADE:
        return (
          <>
            <CardProdutividadeFiltro />
            {carregandoProdutividade && (
              <Loading label="Carregando relatório de produtividade..." />
            )}
            {!carregandoProdutividade && (
              <>
                {imobiliariaSelecionada && (
                  <div className="text-center mt-3 produtividade-imob-corr">
                    <button
                      onClick={() => this.onClickTodos()}
                      type="button"
                      className="btn btn-outline-secondary btnTransparente btnTodos"
                    >
                      Todos
                    </button>
                    <FaChevronRight />
                    <button
                      onClick={() => this.onClickImobiliaria()}
                      className="btnTransparente imobiliariaSelecionada"
                    >
                      <img
                        src={imobiliariaSelecionada.url_imagem}
                        alt={imobiliariaSelecionada.nome}
                      />
                    </button>
                    {detalhesSelecionado && (
                      <>
                        <FaChevronRight />
                        <div
                          className={`${
                            corretorSelecionado ? 'corretor' : 'empreendimento'
                          }Selecionado`}
                        >
                          <img
                            alt={detalhesSelecionado.nome}
                            src={detalhesSelecionado.url_imagem}
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}
                <CardProdutividadeResumo onNavigateToTab={this.handleTabChange} />
                <CardDetalhesVenda />
                <CardCorretoresEmpreendimentos />
                <CardResumoImobiliaria />
              </>
            )}
          </>
        );

      case TABS.PROJECAO:
        return (
          <>
            <CardComissaoFiltro />
            {carregandoComissoes && (
              <Loading label="Carregando relatório de comissão..." />
            )}
            {!carregandoComissoes && (
              <>
                <CardComissaoResumo />
                <CardComissoesMensais />
              </>
            )}
          </>
        );

      case TABS.VENDAS_DETALHADAS:
        return <CardVendasDetalhadas />;

      case TABS.RESCISOES:
        return <RelatorioRescisoes embedded />;

      default:
        return null;
    }
  }

  render() {
    const { activeTab } = this.state;

    return (
      <div className="ProdutividadePage mt-4">
        <div className="produtividade-header">
          <div className="produtividade-header__row">
            <div className="produtividade-header__title">
              <h1>Produtividade</h1>
            </div>

            <nav className="produtividade-tabs">
              <div className="produtividade-tabs__container">
                <button
                  type="button"
                  className={`produtividade-tabs__item ${
                    activeTab === TABS.PRODUTIVIDADE
                      ? 'produtividade-tabs__item--active'
                      : ''
                  }`}
                  onClick={() => this.handleTabChange(TABS.PRODUTIVIDADE)}
                >
                  <FaChartLine className="produtividade-tabs__icon" />
                  <span className="produtividade-tabs__label">
                    Geral
                  </span>
                </button>

                <button
                  type="button"
                  className={`produtividade-tabs__item ${
                    activeTab === TABS.PROJECAO
                      ? 'produtividade-tabs__item--active'
                      : ''
                  }`}
                  onClick={() => this.handleTabChange(TABS.PROJECAO)}
                >
                  <FaChartBar className="produtividade-tabs__icon" />
                  <span className="produtividade-tabs__label">Projeção</span>
                </button>

                <button
                  type="button"
                  className={`produtividade-tabs__item ${
                    activeTab === TABS.VENDAS_DETALHADAS
                      ? 'produtividade-tabs__item--active'
                      : ''
                  }`}
                  onClick={() => this.handleTabChange(TABS.VENDAS_DETALHADAS)}
                >
                  <FaListAlt className="produtividade-tabs__icon" />
                  <span className="produtividade-tabs__label">
                    Vendas Detalhadas
                  </span>
                </button>

                <button
                  type="button"
                  className={`produtividade-tabs__item ${
                    activeTab === TABS.RESCISOES
                      ? 'produtividade-tabs__item--active'
                      : ''
                  }`}
                  onClick={() => this.handleTabChange(TABS.RESCISOES)}
                >
                  <FaFileContract className="produtividade-tabs__icon" />
                  <span className="produtividade-tabs__label">Rescisões</span>
                </button>
              </div>
            </nav>
          </div>
        </div>

        <div className="produtividade-content">{this.renderTabContent()}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  carregandoProdutividade: state.produtividade.carregandoProdutividade,
  carregandoComissoes: state.comissoes.carregandoComissoes,
  imobiliariaSelecionada: state.produtividade.imobiliariaSelecionada,
  corretorSelecionado: state.produtividade.corretorSelecionado,
  empreendimentoSelecionado: state.produtividade.empreendimentoSelecionado,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selecionaCorretor,
      selecionaImobiliaria,
      selecionaEmpreendimento,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Produtividade);
